webpackJsonp([2],{

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var VueSelect = /** @class */ (function (_super) {
    __extends(VueSelect, _super);
    function VueSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VueSelect.prototype.update = function (val) {
        var select = this.$refs.select;
        this.$emit('input', select.value);
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], VueSelect.prototype, "value", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], VueSelect.prototype, "placeholder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], VueSelect.prototype, "options", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], VueSelect.prototype, "defaultValue", void 0);
    VueSelect = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], VueSelect);
    return VueSelect;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (VueSelect);


/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Modal = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], Modal);
    return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (Modal);


/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_site_scss__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_site_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_site_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Core__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Helpers_MomentHelper__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_VueSelect_VueSelect_vue__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_Modal_Modal_vue__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_carousel__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Directives_Sticky_StickyDirective__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__node_modules_brightspark_sparkling_xelect_js_css_sparkling_xelect_css__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__node_modules_brightspark_sparkling_xelect_js_css_sparkling_xelect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__node_modules_brightspark_sparkling_xelect_js_css_sparkling_xelect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__enum__ = __webpack_require__(263);
/* This is a global entry point for a main layout */













__WEBPACK_IMPORTED_MODULE_5__Helpers_MomentHelper__["a" /* MomentHelper */].initLocale();
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].directive("init", new __WEBPACK_IMPORTED_MODULE_2__Core__["a" /* InitDirective */]());
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].directive("sticky", __WEBPACK_IMPORTED_MODULE_9__Directives_Sticky_StickyDirective__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_8_vue_carousel___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].component("v-select", __WEBPACK_IMPORTED_MODULE_6__Components_VueSelect_VueSelect_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].component("v-modal", __WEBPACK_IMPORTED_MODULE_7__Components_Modal_Modal_vue__["a" /* default */]);
//TODO locate to proper place
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('et-EE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
    });
    return formatter.format(value);
});
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter('n2', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('et-EE', {
        minimumFractionDigits: 2
    });
    return formatter.format(value);
});
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter('d', function (value) {
    if (value) {
        return __WEBPACK_IMPORTED_MODULE_4_moment__(String(value)).format("L");
    }
});
if (window.__REQUEST_VIEW) {
    window.view = __WEBPACK_IMPORTED_MODULE_2__Core__["c" /* ViewFactory */].createView(window.__REQUEST_VIEW);
}
// This is a global mixin, it is applied to every vue instance
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].mixin({
    data: function () {
        return {
            get global() {
                return {
                    enum: __WEBPACK_IMPORTED_MODULE_11__enum__["a" /* default */]
                };
            }
        };
    }
});


/***/ }),

/***/ 478:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 488:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MomentHelper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);

var MomentHelper = /** @class */ (function () {
    function MomentHelper() {
    }
    MomentHelper.getDefaultWeekStart = function () {
        return MomentHelper.__defaultWeekStartDay;
    };
    MomentHelper.getCurrentWeekStartDay = function () {
        return MomentHelper.__currentWeekStartDay || MomentHelper.__defaultWeekStartDay;
    };
    MomentHelper.initLocale = function () {
        // Todo get general locale
        var weekStartsWith = MomentHelper.getCurrentWeekStartDay();
        MomentHelper.updateWeekStart(weekStartsWith);
    };
    MomentHelper.updateWeekStart = function (weekStartsWith) {
        var weekSpec = {
            dow: weekStartsWith,
            doy: 4
        };
        var localeSpec = {
            week: weekSpec
        };
        __WEBPACK_IMPORTED_MODULE_0_moment__["updateLocale"]("et", localeSpec);
    };
    MomentHelper.__defaultWeekStartDay = 1;
    MomentHelper.__currentWeekStartDay = null;
    return MomentHelper;
}());



/***/ }),

/***/ 489:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_VueSelect_ts__ = __webpack_require__(260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4943cb5c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VueSelect_vue__ = __webpack_require__(492);
var disposed = false
var normalizeComponent = __webpack_require__(27)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_VueSelect_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4943cb5c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VueSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "www\\js\\Components\\VueSelect\\VueSelect.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4943cb5c", Component.options)
  } else {
    hotAPI.reload("data-v-4943cb5c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "select",
    {
      ref: "select",
      attrs: { placeholder: _vm.placeholder },
      domProps: { value: _vm.value },
      on: {
        change: function($event) {
          _vm.update()
        }
      }
    },
    [
      _vm.defaultValue
        ? _c("option", { attrs: { value: "" } }, [
            _vm._v(_vm._s(_vm.defaultValue))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.options, function(option) {
        return _c(
          "option",
          {
            domProps: {
              value: option.value,
              selected: _vm.value == option.value
            }
          },
          [_vm._v(_vm._s(option.text))]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4943cb5c", esExports)
  }
}

/***/ }),

/***/ 493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_Modal_ts__ = __webpack_require__(261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff8d4db0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(494);
var disposed = false
var normalizeComponent = __webpack_require__(27)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_Modal_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff8d4db0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "www\\js\\Components\\Modal\\Modal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ff8d4db0", Component.options)
  } else {
    hotAPI.reload("data-v-ff8d4db0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 494:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c("div", { staticClass: "modal-mask" }, [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c("div", { staticClass: "modal-container" }, [
          _c("div", { staticClass: "modal-header" }, [_vm._t("header")], 2),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [_vm._t("body")], 2),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [_vm._t("footer")], 2)
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ff8d4db0", esExports)
  }
}

/***/ }),

/***/ 495:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__throttle__ = __webpack_require__(496);

var listenAction;
var supportCssSticky;
var getBindingConfig = function (binding) {
    var params = binding.value || {};
    var stickyTop = params.stickyTop || 0;
    var zIndex = params.zIndex || 1000;
    var disabled = params.disabled;
    return { stickyTop: stickyTop, zIndex: zIndex, disabled: disabled };
};
var getInitialConfig = function (el) {
    return {
        zIndex: el.style.zIndex,
    };
};
var unwatch = function () {
    window.removeEventListener("scroll", listenAction);
};
var watch = function () {
    window.addEventListener("scroll", listenAction);
};
var bindingConfig = {};
var initialConfig = {};
/* harmony default export */ __webpack_exports__["a"] = ({
    bind: function (el, binding) {
        bindingConfig = getBindingConfig(binding);
        initialConfig = getInitialConfig(el);
        var disabled = bindingConfig.disabled, stickyTop = bindingConfig.stickyTop, zIndex = bindingConfig.zIndex;
        if (disabled) {
            return;
        }
        var elStyle = el.style;
        elStyle.position = '-webkit-sticky';
        elStyle.position = 'sticky';
        var childStyle = el.firstElementChild.style;
        // test if the browser support css sticky
        supportCssSticky = ~elStyle.position.indexOf('sticky');
        if (supportCssSticky) {
            elStyle.top = stickyTop + "px";
            elStyle.zIndex = zIndex;
        }
        else {
            elStyle.position = '';
            //childStyle.cssText = `left: 0; right: 0; top: ${stickyTop}px; z-index: ${zIndex}; ${childStyle.cssText}`;
            childStyle.cssText = "top: " + stickyTop + "px; z-index: " + zIndex + "; " + childStyle.cssText;
        }
        var active = false;
        var sticky = function () {
            if (supportCssSticky || active) {
                return;
            }
            if (!elStyle.height) {
                elStyle.height = el.offsetHeight + "px";
            }
            if (childStyle) {
                childStyle.position = "fixed";
            }
            active = true;
        };
        var reset = function () {
            if (supportCssSticky || !active) {
                return;
            }
            childStyle.position = "static";
            active = false;
        };
        listenAction = Object(__WEBPACK_IMPORTED_MODULE_0__throttle__["a" /* default */])(function () {
            var offsetTop = el.getBoundingClientRect().top;
            if (offsetTop <= stickyTop) {
                return sticky();
            }
            reset();
        });
        watch();
    },
    unbind: unwatch,
    update: function (el, binding) {
        bindingConfig = getBindingConfig(binding);
        var stickyTop = bindingConfig.stickyTop, zIndex = bindingConfig.zIndex;
        var childStyle = el.firstElementChild.style;
        if (supportCssSticky) {
            el.style.top = stickyTop + "px";
            el.style.zIndex = zIndex;
        }
        else {
            childStyle.top = stickyTop + "px";
            childStyle.zIndex = zIndex;
        }
        if (bindingConfig.disabled) {
            if (supportCssSticky) {
                el.style.position = "";
            }
            else {
                childStyle.position = "";
                childStyle.top = "";
                childStyle.zIndex = initialConfig.zIndex;
                unwatch();
            }
            return;
        }
        if (supportCssSticky) {
            el.style.position = '-webkit-sticky';
            el.style.position = 'sticky';
        }
        else {
            watch();
        }
    },
});


/***/ }),

/***/ 496:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (fn, delay) {
    if (delay === void 0) { delay = 100; }
    var now, lastExec, timer, context, args;
    function execute() {
        fn.apply(context, args);
        lastExec = now;
    }
    var f = function () {
        args = arguments;
        now = +new Date();
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        if (!lastExec) {
            execute();
        }
        else {
            var diff = delay - (now - lastExec);
            if (diff < 0) {
                execute();
            }
            else {
                timer = setTimeout(function () {
                    execute();
                }, diff);
            }
        }
    };
    context = f;
    return f;
});;


/***/ })

},[275]);


// WEBPACK FOOTER //
// js/global.bundle.js